import clsx from 'clsx';
import React, { useEffect, useState } from 'react';

import { CssModuleType } from '@utils/cssModules';

import currentCssModule from './SelectWithLabels.module.scss';

interface SelectWithLabelsProps extends React.PropsWithChildren<any> {
    beforeLabel?: string;
    afterLabel?: string;
    options: any[];
    onChange: (option) => void;
    minWidth?: boolean;
    justifyContent?: string;
    defaultValue: string;
    defaultOrder: string;
}

const SelectWithLabels: React.FC<SelectWithLabelsProps> = ({
    beforeLabel,
    afterLabel,
    options,
    onChange,
    minWidth = false,
    justifyContent = 'start',
    defaultValue,
    defaultOrder
}) => {
    const st: CssModuleType = currentCssModule;

    const [isOpen, setIsOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(
        options?.find(
            (item) => item.data === defaultValue && item.sort_order === defaultOrder && item.display_name
        )
    );

    useEffect(() => {
        setSelectedValue(
            options?.find(
                (item) =>
                    item.data === defaultValue && item.sort_order === defaultOrder && item.display_name
            )
        );
    }, [defaultValue]);

    const handleOptionClick = (option) => {
        console.log('handleOptionClick:', option);
        setSelectedValue(option);
        onChange(option);
        setIsOpen(false);
    };

    const renderSelectedValue = () => {
        if (!options) return;
        if (!selectedValue) return options[0]?.display_name;
        return selectedValue.display_name;
    };

    return (
        <div
            className={clsx(
                st['select-with-labels'],
                st[`justify-${justifyContent}`]
            )}
        >
            {beforeLabel && (
                <label className={st['label--left']}>{beforeLabel}</label>
            )}
            <ul
                onMouseEnter={() => setIsOpen(true)}
                onMouseLeave={() => setIsOpen(false)}
                className={minWidth ? st['min-width'] : ''}
            >
                <li className={st.selected}>{renderSelectedValue()}</li>
                {options && isOpen && (
                    <ul>
                        {options.map((option, ind) => (
                            <li
                                data-data={option.data}
                                key={`${option.data}_${ind}`}
                                onClick={() => handleOptionClick(option)}
                            >
                                {option.display_name}
                            </li>
                        ))}
                    </ul>
                )}
            </ul>
            {afterLabel && (
                <label className={st['label--right']}>{afterLabel}</label>
            )}
        </div>
    );
};

export default SelectWithLabels;
